import axios from 'axios'
import { useState } from 'react'
import { useEffect } from 'react'
import { Collapse, Container, Row } from 'react-bootstrap'

import configs from '../../config'
import Cookies from 'js-cookie'

const UserInfo = ({ open = false, toggleFn = () => {}, lotteries = [] }) => {
  const userLottery = lotteries.reduce((acc, cur) => {
    if (!acc[cur.user.id]) {
      acc[cur.user.id] = []
    }
    acc[cur.user.id].push(cur)
    return acc
  }, {})

  return (
    <Container fluid>
      <Row className="justify-content-center">User Info</Row>
      <Collapse in>
        <div id="collapse-info">
          {Object.keys(userLottery).map((userId) => (
            <Info key={`user-info-${userId}`} userId={userId} lotteries={userLottery[userId]} />
          ))}
        </div>
      </Collapse>
    </Container>
  )
}

const Info = ({ userId = '', lotteries = [] }) => {
  const [user, setUser] = useState(null)

  useEffect(() => {
    if (!userId) return
    ;(async () => {
      try {
        const res = await axios.get(`${configs.apiAdminGateway}/api/v1/admin/users/${userId}`, {
          headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` },
        })

        const {
          status: { code, description },
          data,
        } = res.data

        if (code !== 0) {
          throw new Error(description)
        }

        setUser(data)
      } catch (err) {
        setUser(null)
      }
    })()
  }, [userId])

  return (
    <Container>
      <div>
        ชื่อเล่น : {user ? `${user.nickName}` : 'เดี๋ยวก็รวย'} {`(${lotteries.length} ใบ)`}
      </div>
      <div>จังหวัด : {user ? `${user.address?.province}` : 'กรุงเทพมหานคร'}</div>
      <div>เบอร์โทร : {user ? `${user.phone.slice(0, 1)}XXXXXXX${user.phone.slice(-3)}` : '0XXXXXX804'}</div>
      <hr />
    </Container>
  )
}

export default UserInfo
